export default __webpack_public_path__ + "static/media/icon-audit-logs.9939907b.svg";